// extracted by mini-css-extract-plugin
module.exports = {"level-2-bg":"PlaywireAd_level-2-bg__Avsnd","container":"PlaywireAd_container__BQG6z","container__type--sky_atf":"PlaywireAd_container__type--sky_atf__js7wX"};